import React, { Component } from 'react';
import { Route, Switch } from 'react-router';
import { BrowserRouter as Router, Redirect } from 'react-router-dom';
import moment from 'moment';
import Promise from 'bluebird';
import axios from 'axios/index';
import Navbar from '../Navbar/Navbar';
import NotFound from '../NotFound/NotFound';
import Status from '../Status/Status';
import Closings from '../Closings/Closings';
import Trades from '../Trades/Trades';
import BetsOverview from '../BetsOverview/BetsOverview';
import Auth from '../Auth/Auth';
import { API_BASE, API_TIMEOUT } from '../../constants';
import './App.css';

export default class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isUnauthed: false,
      isLoading: false,
      error: null,
      lastLoadTime: null,
      routes: [
        { path: '/', title: 'Home', component: Status },
        { path: '/trades-overview', title: 'Bets Overview', component: BetsOverview },
        { path: '/open-trades', title: 'Open Trades', component: Trades, props: { type: 'open' } },
        { path: '/reconciled-trades', title: 'Settled Trades', component: Trades, props: { type: 'reconciled', profitLoss: true } },
        { path: '/profit-graph', title: 'Profit Graph', component: Closings },
        // { path: '/order-id', title: 'Order ID to Bet', component: OrderIdToBet },
        // { path: '/flux', title: 'Flux', component: Flux },
        { path: '/auth', component: Auth },
      ],
    };

    this.setAxiosDefaults();
  }

  setAxiosDefaults() {
    axios.defaults.baseURL = API_BASE;
    axios.defaults.timeout = API_TIMEOUT;
    axios.defaults.withCredentials = true;
    axios.defaults.headers['Content-Type'] = 'application/json';
    axios.interceptors.response.use((res) => {
      if (!(res.data instanceof Object) || res.statusText !== 'OK') {
        return Promise.reject(res);
      }
      this.setState({ isUnauthed: false });
      return res.data;
    }, (error) => {
      if (error.response instanceof Object && error.response.status === 401) {
        this.setState({ isUnauthed: true });
      }

      return Promise.reject(error);
    });
  }

  updateRefresh(isLoading, error) {
    this.setState({
      isLoading,
      error,
    });
    if (!error && !isLoading) {
      this.setState({ lastLoadTime: moment() });
    }
  }

  renderRouteComponent(props, route) {
    if (this.state.isUnauthed && route.component.isPrivate) return <Redirect to={{ pathname: '/auth' }} />;

    return React.createElement(route.component, {
      key: route.path,
      updateRefresh: (...args) => this.updateRefresh(...args),
      ...route.props,
      ...props,
    });
  }

  /* eslint-disable react/jsx-first-prop-new-line */
  /* eslint-disable react/jsx-max-props-per-line */
  /* eslint-disable react/jsx-closing-bracket-location */
  render() {
    return (
      <Router>
        <div className={`app container-fluid ${this.state.isNavbarExpanded && 'routes--navbar'}`}>
          <Route path="/" render={props => (
            <Navbar
              routes={this.state.routes}
              onToggle={isNavbarExpanded => this.setState({ isNavbarExpanded })}
              isLoading={this.state.isLoading}
              error={this.state.error}
              lastLoadTime={this.state.lastLoadTime}
              {...props}
            />
          )} />

          <Switch>
            {this.state.routes.map(route => (
              <Route
                key={`${route.path}-route`}
                exact
                path={route.path}
                render={props => this.renderRouteComponent(props, route)}
              />
            ))}
            <Route component={NotFound} />
          </Switch>
        </div>
      </Router>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/App.js